export default __webpack_public_path__ + "static/media/AHRR using nhexane 1000RPM 0.75mol fueltot.fd6df5d9.png";